define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dijit/form/DropDownButton",
	"dijit/MenuItem",
	"csi/_base/underscore",
	"csi/action",
	"csi/html",
	"csi/view/ToolbarPlugin",
	"csi/widget/Menu",
	"./util"
], function(array,declare,lang,DropDownButton,MenuItem,_,csiAction,html,ToolbarPlugin,Menu,util) {

	return declare([DropDownButton, ToolbarPlugin], {
		postMixInProperties: function() {
			// summary: set appearance based on action
			this._mixinActionProperties();
			this.inherited(arguments);
		},

		postCreate: function() {
			// summary: set up all available export batches
			this.inherited(arguments);

			var	view = this.actionToolbar.view;
			var cache = view.cacheView;
			var action = this.defAction;
			var node = cache.getPathNode(view.getViewNode(),action.m_path);
			var	urlNode = node.$URL;
			var menu = new Menu({});

			// create menu items for each batch
			var batches = util.getManuallyTriggeredBatchesForType(node.$Type,cache);
			array.forEach(batches,function(batch){
		        var menuItem = new MenuItem({
		            label: _.escape(batch.$Name),
		            pluginName: this.pluginName,
		            onClick: lang.hitch(this, this._onClick, action, batch.$URL)
		        });
		        menu.addChild(menuItem);
			},this);

			html.setElementContext(menu.domNode, urlNode);
			menu.startup();

			this.dropDown = menu;
		},

	    _onClick: function(action, urlBatch,event) {
	    	if (event) {
	    		csiAction.invoke(null,event.target,action,{urlBatch:urlBatch});
	    	}
	    }
	});
});
